import React from "react";
import { habitacional, SeguroEmpresarial } from "../../../../../config/links";
import { ReactComponent as PersonIcon } from "../../../../../assets/images/icons/person-icon.svg";
import { links } from "../../../../../config";

export const menuLinks = [
  {
    label: "Início",
    href: "/",
  },
  {
    label: "Para você",
    href: habitacional.home,
    submenu: [
      { label: "Seguro Habitacional", href: links.habitacional.home },
      { label: "Seguro Residencial", href: links.residencial.home },
      { label: "divider", isDivider: true },
      {
        label: (
          <div className="column-start">
            Seguro Auto <br /> <span>(até 21/05/2021)</span>
          </div>
        ),
        href: links.seguroAutoAntigo,
      },
      {
        label: (
          <div className="column-start">
            Seguro Auto <br /> <span>(a partir de 22/05/2021)</span>
          </div>
        ),
        href: links.seguroAutoNovo,
      },
      { label: "Seguro Saúde", href: links.seguroSaude },
    ],
  },
  {
    label: "Para sua empresa",
    href: SeguroEmpresarial,
    submenu: [
      {
        label: "Seguro Empresarial",
        href: "/pj/mge/Paginas/Seguro-Empresarial.aspx",
      },
      {
        label: "Seguro Saúde",
        href: "/pj/mge/Paginas/seguro-saude.aspx",
      },
    ],
  },
  {
    label: "Sobre nós",
    href: "www",
    submenu: [
      {
        label: "A Caixa Seguradora",
        href: "/Sobre-a-empresa/Paginas/home-sobre-a-empresa.aspx",
      },
      {
        label: "Publicações",
        href: "/sobre-a-empresa/Paginas/Downloads.aspx",
      },
      { label: "divider 3", isDivider: true },
      {
        label: "Responsabilidade Socioambiental",
        href: "/sobre-a-empresa/Paginas/Programas-Socioambientais.aspx",
      },
    ],
  },
  {
    label: "Atendimento",
    href: links.atendimento,
  },
  {
    label: (
      <>
        <div>
          <PersonIcon /> Fazer login
        </div>
      </>
    ),
    href: links.areaLogada,
    isExternalLink: true,
    isOnlyMobile: true,
  },
];
